export enum EChallengeStatus {
  Waiting = 'waiting_for_opponent',
  Accepted = 'accepted',
  Retracted = 'retracted',
  Expired = 'expired',
  Finished = 'finished',
}

export interface IParticipantData {
  id: number;
  first_name: string;
  last_name: string;
}

export interface IDebateSettings {
  debate_challenge: number;
  rounds_per_participant: number;
  round_duration: number;
  debate_duration: number;
}

export type TChallengeStatus =
  | EChallengeStatus.Waiting
  | EChallengeStatus.Accepted
  | EChallengeStatus.Retracted
  | EChallengeStatus.Expired
  | EChallengeStatus.Finished;

export interface ICreateChallengeRequest {
  thesis: string;
  description: string;
  auto_start: boolean;
  initiator: number;
  start_datetime: number;
  opponent?: number;
  picture_link?: string;
  pre_created_stream?: number;
  debate_settings: {
    rounds_per_participant: number;
    round_duration: number;
  };
}

export interface IChallangeData {
  id: number;
  opponent: IParticipantData;
  initiator: IParticipantData;
  debate_settings: IDebateSettings;
  thesis: string;
  description: string;
  status: TChallengeStatus;
  auto_start: boolean;
  picture_link: string;
  created_at: number;
  start_datetime: number;
  debate_id: number | null;
}
